import {get} from "./http";
import {baseUrl} from "@/config";

const requireJson = (file)=>get(`${baseUrl}lexus_mini_web/data/${file}`,{},{intact:true})


export default requireJson
